import { render, staticRenderFns } from "./AccommodationSelect.vue?vue&type=template&id=a518ca68"
import script from "./AccommodationSelect.vue?vue&type=script&lang=ts"
export * from "./AccommodationSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports